import React from "react";
import { Col, Row, Typography, Table } from "antd";
import { formatNumber } from "../../../../utils/common";

const { Title, Text } = Typography;

const ContentSection = ({ title, data, type }) => {
  // Filter data based on section type
  const filteredData = React.useMemo(() => {
    if (type === "pointBonus") {
      return data?.filter((item) => !item.nft_reward_name);
    } else if (type === "nftReward") {
      return data?.filter((item) => item.nft_reward_name);
    } else if (type === "rebateBonus") {
      return data?.filter((item) => !item.nft_reward_name);
    }
    return [];
  }, [data, type]);

  // Define columns based on section type
  const columns = React.useMemo(() => {
    if (type === "pointBonus") {
      return [
        {
          title: "Tier Range",
          dataIndex: "tier",
          key: "tier",
          align: 'center',
          width: 400,
          render: (_, record) => record.from_tier === record.to_tier ? `${record.from_tier}` : `${record.from_tier} - ${record.to_tier}`,
        },
        {
          title: "Bonus Point Return Rate",
          dataIndex: "point_bonus_reward",
          key: "point_bonus_reward",
          align: 'center',
          render: (value) => `${formatNumber(value)}%`,
        },
      ];
    } else if (type === "nftReward") {
      return [
        {
          title: "Tier",
          dataIndex: "tier",
          key: "tier",
          align: 'center',
          width: 400,
        },
        {
          title: "NFT Reward",
          dataIndex: "nft_reward_name",
          key: "nft_reward_name",
          align: 'center'
        },
      ];
    } else if (type === "rebateBonus") {
      return [
        {
          title: "Tier Range",
          dataIndex: "tier",
          key: "tier",
          align: 'center',
          width: 400,
          render: (_, record) => record.from_tier === record.to_tier ? `${record.from_tier}` : `${record.from_tier} - ${record.to_tier}`,
        },
        {
          title: "Rebate Rate",
          dataIndex: "rebate_bonus_reward",
          key: "rebate_bonus_reward",
          align: 'center',
          render: (value) => `${formatNumber(value)}%`,
        },
      ];
    }
    return [];
  }, [type]);

  return (
    <div style={{ width: "100%", position: "relative", marginBottom: 30 }}>
      <Row justify="center" style={{ marginBottom: 18 }}>
        <Col span={24}>
          <Title level={3} style={{ color: "#156df2", display: "inline" }}>
            {title.stt}.
          </Title>
          <Title level={3} style={{ color: "#fff", display: "inline" }}>
            {" "}
            {title.name}
          </Title>
        </Col>
        <Col span={24}>
          <Text style={{ color: "#fff" }}>{title.subText}</Text>
        </Col>
      </Row>

      <Table
        dataSource={filteredData}
        columns={columns}
        pagination={false}
        rowKey={(record) => `${record.from_tier}-${record.to_tier}`}
        className="bonus-reward-table"
      />
    </div>
  );
};

export default ContentSection;
